"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function RollbackactionGreenMultitoneFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 10.609,
    height: 0.907,
    fill: "#FF730E",
    rx: 0.454,
    transform: "matrix(1 0 0 -1 1.102 2.664)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "orion-icon-rollbackaction-green-multitone-filled-a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.984 2.65a2.578 2.578 0 00-5.155 0H8.984z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#FF730E",
    strokeWidth: 1.6,
    d: "M8.984 2.65a2.578 2.578 0 00-5.155 0H8.984z",
    mask: "url(#orion-icon-rollbackaction-green-multitone-filled-a)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9549",
    fillRule: "evenodd",
    d: "M10.804 3.272H2.009v8.65a1 1 0 001 1h2.784a5 5 0 015.01-6.267V3.272z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.623,
    cy: 11.652,
    r: 4.275,
    fill: "#FF730E"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8.673 10.502a.145.145 0 010-.217l1.323-1.28a.179.179 0 01.238 0 .145.145 0 010 .217L9.196 10.24h1.943c1.019 0 1.845.757 1.845 1.69 0 .935-.826 1.692-1.845 1.692H8.791v-.308h2.348c.834 0 1.51-.62 1.51-1.383 0-.764-.676-1.384-1.51-1.384H9.196l1.037 1.032a.145.145 0 010 .218.179.179 0 01-.237 0l-1.323-1.295z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9.996 11.797c.066.06.172.06.237 0a.145.145 0 000-.218l-1.037-1.032h1.943c.834 0 1.51.62 1.51 1.384 0 .764-.676 1.383-1.51 1.383H8.791v.308h2.348c1.019 0 1.845-.757 1.845-1.691s-.826-1.691-1.845-1.691H9.196l1.038-1.018a.145.145 0 000-.218.179.179 0 00-.238 0l-1.323 1.28a.145.145 0 000 .218l1.323 1.295zm-1.46-1.153a.341.341 0 01.001-.502L9.863 8.86a.375.375 0 01.503 0c.15.137.15.366.003.504l-.692.68h1.462c1.11 0 2.041.829 2.041 1.887s-.93 1.887-2.041 1.887H8.595v-.7h2.544c.742 0 1.313-.548 1.313-1.187 0-.64-.572-1.187-1.313-1.187H9.672l.697.694a.341.341 0 01-.003.504.375.375 0 01-.503 0l-.004-.005-1.322-1.293z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    d: "M10.807 3.295H8.821v3.689l.448-.149.528-.129.53-.06h.48V3.295z"
  }));
}

RollbackactionGreenMultitoneFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
RollbackactionGreenMultitoneFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = RollbackactionGreenMultitoneFilled;
exports["default"] = _default;